import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { equals as e } from "../../../core/arrayUtils.js";
import t from "../../../core/Evented.js";
import { isSome as s } from "../../../core/maybe.js";
import i from "../../../geometry/Polygon.js";
import r from "../../../geometry/Polyline.js";
import { createCoordinateHelper as o } from "../coordinateHelper.js";
import { unnormalize as n, getUnnormalizationInfo as h } from "./unnormalizationHelper.js";

var c = /*#__PURE__*/function () {
  function c(e) {
    _classCallCheck(this, c);

    this.component = e, this.leftEdge = null, this.rightEdge = null, this.type = "vertex", this.index = null;
  }

  _createClass(c, [{
    key: "pos",
    get: function get() {
      return this._pos;
    },
    set: function set(e) {
      this._pos = e, this.component.unnormalizeVertexPositions();
    }
  }]);

  return c;
}();

var l = function l(e, t, s) {
  _classCallCheck(this, l);

  this.component = e, this.leftVertex = t, this.rightVertex = s, this.type = "edge", t.rightEdge = this, s.leftEdge = this;
};

var p = /*#__PURE__*/function () {
  function p(e, t) {
    _classCallCheck(this, p);

    this.spatialReference = e, this.viewingMode = t, this.vertices = [], this.edges = [];
  }

  _createClass(p, [{
    key: "unnormalizeVertexPositions",
    value: function unnormalizeVertexPositions() {
      this.vertices.length <= 1 || n(this.vertices, h(this.spatialReference, this.viewingMode));
    }
  }, {
    key: "updateVertexIndex",
    value: function updateVertexIndex(e, t) {
      if (0 === this.vertices.length) return;
      var s = this.vertices[0];
      var i = null,
          r = e,
          o = t;

      do {
        i = r, i.index = o++, r = i.rightEdge ? i.rightEdge.rightVertex : null;
      } while (null != r && r !== s);

      i.leftEdge && i !== this.vertices[this.vertices.length - 1] && this.swapVertices(this.vertices.indexOf(i), this.vertices.length - 1);
    }
  }, {
    key: "getFirstVertex",
    value: function getFirstVertex() {
      return 0 === this.vertices.length ? null : this.vertices[0];
    }
  }, {
    key: "getLastVertex",
    value: function getLastVertex() {
      return 0 === this.vertices.length ? null : this.vertices[this.vertices.length - 1];
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.vertices.length > 2 && null !== this.vertices[0].leftEdge;
    }
  }, {
    key: "swapVertices",
    value: function swapVertices(e, t) {
      var s = this.vertices[e];
      this.vertices[e] = this.vertices[t], this.vertices[t] = s;
    }
  }, {
    key: "iterateVertices",
    value: function iterateVertices(e) {
      if (0 === this.vertices.length) return;
      var t = this.vertices[0];
      var i = t;

      do {
        e(i, i.index), i = s(i.rightEdge) ? i.rightEdge.rightVertex : null;
      } while (i !== t && null != i);
    }
  }]);

  return p;
}();

var g = /*#__PURE__*/function (_t) {
  _inherits(g, _t);

  var _super = _createSuper(g);

  function g(e, t, s) {
    var _this;

    _classCallCheck(this, g);

    _this = _super.call(this), _this.type = e, _this.coordinateHelper = t, _this.viewingMode = s, _this._geometry = null, _this.dirty = !0, _this.components = [];
    return _this;
  }

  _createClass(g, [{
    key: "geometry",
    get: function get() {
      if (this.dirty) {
        switch (this.type) {
          case "point":
            this._geometry = this.toPoint();
            break;

          case "polyline":
            this._geometry = this.toPolyline();
            break;

          case "polygon":
            this._geometry = this.toPolygon();
        }

        this.dirty = !1;
      }

      return this._geometry;
    }
  }, {
    key: "spatialReference",
    get: function get() {
      return this.coordinateHelper.spatialReference;
    }
  }, {
    key: "notifyChanges",
    value: function notifyChanges(e) {
      this.dirty = !0, this.emit("change", e);
    }
  }, {
    key: "toPoint",
    value: function toPoint() {
      return 0 === this.components.length || 0 === this.components[0].vertices.length ? null : this.coordinateHelper.vectorToPoint(this.components[0].vertices[0].pos);
    }
  }, {
    key: "toPolyline",
    value: function toPolyline() {
      var e = [],
          t = this.coordinateHelper.vectorToArray;
      return this.components.forEach(function (s, i) {
        var r = [];
        var o = s.vertices.find(function (e) {
          return null == e.leftEdge;
        });
        var n = o;

        do {
          r.push(t(o.pos)), o = o.rightEdge ? o.rightEdge.rightVertex : null;
        } while (o && o !== n);

        e.push(r);
      }), new r({
        paths: e,
        spatialReference: this.spatialReference,
        hasZ: this.coordinateHelper.hasZ(),
        hasM: this.coordinateHelper.hasM()
      });
    }
  }, {
    key: "toPolygon",
    value: function toPolygon() {
      var e = [],
          t = this.coordinateHelper.vectorToArray;
      return this.components.forEach(function (i, r) {
        var o = [],
            n = i.vertices[0];
        var h = n;
        var c = h;

        do {
          o.push(t(h.pos)), h = s(h.rightEdge) ? h.rightEdge.rightVertex : null;
        } while (h && h !== c);

        i.isClosed() && o.push(t(n.pos)), e.push(o);
      }), new i({
        rings: e,
        spatialReference: this.spatialReference,
        hasZ: this.coordinateHelper.hasZ(),
        hasM: this.coordinateHelper.hasM()
      });
    }
  }], [{
    key: "fromGeometry",
    value: function fromGeometry(t, s) {
      var i = t.spatialReference,
          r = o(t.hasZ, t.hasM, i),
          n = new g(t.type, r, s);

      switch (t.type) {
        case "polygon":
          {
            var _o = t.rings;

            for (var _t2 = 0; _t2 < _o.length; ++_t2) {
              var _h = _o[_t2],
                  _g2 = new p(i, s),
                  a = _h.length > 2 && e(_h[0], _h[_h.length - 1]),
                  d = a ? _h.length - 1 : _h.length;

              for (var _e = 0; _e < d; ++_e) {
                var _t3 = r.arrayToVector(_h[_e]),
                    _s = new c(_g2);

                _g2.vertices.push(_s), _s.pos = _t3, _s.index = _e;
              }

              var u = _g2.vertices.length - 1;

              for (var _e2 = 0; _e2 < u; ++_e2) {
                var _t4 = _g2.vertices[_e2],
                    _s2 = _g2.vertices[_e2 + 1],
                    _i = new l(_g2, _t4, _s2);

                _g2.edges.push(_i);
              }

              if (a) {
                var _e3 = new l(_g2, _g2.vertices[_g2.vertices.length - 1], _g2.vertices[0]);

                _g2.edges.push(_e3);
              }

              n.components.push(_g2);
            }

            break;
          }

        case "polyline":
          var _iterator = _createForOfIteratorHelper(t.paths),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _e4 = _step.value;

              var _t5 = new p(i, s),
                  _o2 = _e4.length;

              for (var _s3 = 0; _s3 < _o2; ++_s3) {
                var _i2 = r.arrayToVector(_e4[_s3]),
                    _o3 = new c(_t5);

                _t5.vertices.push(_o3), _o3.pos = _i2, _o3.index = _s3;
              }

              var _h2 = _t5.vertices.length - 1;

              for (var _e5 = 0; _e5 < _h2; ++_e5) {
                var _s4 = _t5.vertices[_e5],
                    _i3 = _t5.vertices[_e5 + 1],
                    _r = new l(_t5, _s4, _i3);

                _t5.edges.push(_r);
              }

              n.components.push(_t5);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          break;

        case "point":
          {
            var _e6 = new p(i, s),
                _o4 = new c(_e6);

            _o4.index = 0, _o4.pos = r.pointToVector(t), _e6.vertices.push(_o4), n.components.push(_e6);
            break;
          }
      }

      return n;
    }
  }]);

  return g;
}(t);

export { p as Component, l as Edge, g as EditGeometry, c as Vertex };